import { createFileRoute, redirect } from '@tanstack/react-router';

// My work (CO-0441) is the lane Te doen of Werk now (CO-1386, ADR-0038); old links keep working.
export const Route = createFileRoute('/_app/my-work')({
  beforeLoad: () => {
    throw redirect({ to: '/werk', search: { lane: 'todo' } });
  },
});
